import React from 'react'
import { connectStateResults } from 'react-instantsearch-dom'
import clsx from 'clsx'
import { ResultsSectionProps } from '@/components/molecules/IndexContent/types'

function ResultsSection({ searchResults, children }: ResultsSectionProps): React.ReactElement {
  return (
    <section
      className={clsx(
        'border-b border-solid border-grey-100 pb-24 mb-64',
        searchResults?.nbPages <= 1 && 'pagination-hidden'
      )}
    >
      {children}
    </section>
  )
}

export const IndexContent = connectStateResults(ResultsSection)
